<section>
    <div class="content">
        <div class="socialmedia">
            <div class="left">
                <img class="fault-line" src="assets/images/fault-line.png" />
                <div class="iconrow">
                    <a href="https://github.com/Irina-Gorges/" target="_blank"><img class="iconimg" src="assets/icons/Github button.png" alt="Github" /></a>
                    <a href="mailto:irinagorges&#64;live.de"><img class="iconimg" src="assets/icons/Email button.png" alt="" /></a>
                    <a href="https://www.linkedin.com/in/irina-g-656486340/" target="_blank"><img class="iconimg" src="assets/icons/Linkedin button.png" alt="" /></a>
                </div>
                <span class="email">irinagorges&#64;live.de</span>
            </div>
        </div>
        <div class="scrolldown" (click)="scrollToDown()">
            <span>{{text.scroll}}</span>
            <img src="assets/icons/arrow-down-line.png" alt="">
        </div>
    </div>
</section>